export function createPluginInstallError(pluginName: string, errorMessage: string): Error {
  return new Error(`Plugin "${pluginName}" installation error: ${errorMessage}`);
}
